import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { removeParkingServiceImage } from '../../api/parking-service.ts';
import { RemoveParkingServiceImageRequest } from '../../api/requests/parking-service-request.ts';

export default function useRemoveParkingServiceImage(): UseMutationResult<
  Awaited<ReturnType<typeof removeParkingServiceImage>>,
  Error,
  RemoveParkingServiceImageRequest
> {
  return useMutation({
    mutationFn: removeParkingServiceImage,
  });
}
